var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFullScreenNeumorphic = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 50,
  height: 56,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#FullScreenNeumorphic_svg__a)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 28.579,
  height: 29.373,
  x: 8,
  y: 10,
  fill: "url(#FullScreenNeumorphic_svg__b)",
  fillOpacity: 0.6,
  rx: 8
}))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#888",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.25,
  d: "M26.15 17.794h3.43M29.58 21.225v-3.43M29.579 28.943v3.43M26.149 32.373h3.43M18.43 32.373H15M15 28.942v3.43M15 21.225v-3.43M18.43 17.794H15M29.579 32.373l-5.145-5.145M20.146 22.94 15 17.794M20.146 27.228 15 32.373M29.579 17.794l-5.145 5.146"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "FullScreenNeumorphic_svg__b",
  x1: 11.079,
  x2: 33.079,
  y1: 37,
  y2: 14.5,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#DADADA"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff"
})), /*#__PURE__*/React.createElement("filter", {
  id: "FullScreenNeumorphic_svg__a",
  width: 48.786,
  height: 54.888,
  x: 0.401,
  y: 0.213,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: -2.599,
  dy: -4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.375 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_247_9198"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: -2.599
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.44708 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "effect1_dropShadow_247_9198",
  result: "effect2_dropShadow_247_9198"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: -2.599,
  dy: -4.787
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2.5
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.539141 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "effect2_dropShadow_247_9198",
  result: "effect3_dropShadow_247_9198"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: -2.599,
  dy: 3
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2.5
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.75 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "effect3_dropShadow_247_9198",
  result: "effect4_dropShadow_247_9198"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 3.899,
  dy: 4.549
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2.924
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.8875 0 0 0 0 0.8875 0 0 0 0 0.8875 0 0 0 0.48 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "effect4_dropShadow_247_9198",
  result: "effect5_dropShadow_247_9198"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 3.899,
  dy: 3.639
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2.469
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.875 0 0 0 0 0.875 0 0 0 0 0.875 0 0 0 0.4 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "effect5_dropShadow_247_9198",
  result: "effect6_dropShadow_247_9198"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 3.899,
  dy: 3.119
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2.21
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.875 0 0 0 0 0.875 0 0 0 0 0.875 0 0 0 0.34 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "effect6_dropShadow_247_9198",
  result: "effect7_dropShadow_247_9198"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 3.899,
  dy: 7.019
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4.354
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.9 0 0 0 0 0.9 0 0 0 0 0.9 0 0 0 0.67 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "effect7_dropShadow_247_9198",
  result: "effect8_dropShadow_247_9198"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect8_dropShadow_247_9198",
  result: "shape"
})))));
export default SvgFullScreenNeumorphic;